import { defineNuxtPlugin, useVideoContextMenuOptionsShowStatesStore } from '#imports'
import type { DirectiveBinding } from '#imports'
import { useAuthStore } from '../stores/authStore'
import { useCmsEditStore } from '../stores/cmsEditStore'
import type { CmsVideo } from '../types/cmsTypes'

interface CmsHandlerEvent {
  event?: EventListener | ((e: KeyboardEvent) => void)
  event_type: keyof WindowEventMap
  target: HTMLElement | Window
}

interface CmsElement extends HTMLVideoElement {
  __cmsHandlers: CmsHandlerEvent[]
  _cmsPath: string[]
  _global: boolean
  __cmsLabel?: HTMLElement
}

let chosenPath: string[] | undefined
let isChoosenGlobal: boolean = false

export function update_cms_values(newValues: CmsVideo): void {
  if (!chosenPath) return
  const editStore = useCmsEditStore()
  editStore.set(chosenPath, { component_type: 'CmsVideo', component_data: newValues }, isChoosenGlobal)
}

export function getcurrentChosenElement(): string[] | undefined {
  return chosenPath
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('cms-video-element', {
    mounted(el: CmsElement, binding: DirectiveBinding) {
      const authStore = useAuthStore()
      if (!authStore.authorized) return

      if (!binding.value) {
        el.style.border = '2px solid red'
        return
      }

      // if (!binding.arg) {
      //   el.innerHTML = 'NO ARG GIVEN'
      //   return
      // }

      const editStore = useCmsEditStore()
      const { path, global = false } = binding.value as {
        path: string[]
        global: boolean
      }

      el._cmsPath = path
      el.__cmsHandlers = []
      el._global = global

      editStore.set(path, { component_type: 'CmsVideo', component_data: binding.arg as CmsVideo }, global)

      const mouseEnterHandler = () => {
        el.style.outline = '2px solid blue'
      }
      const mouseLeaveHandler = () => {
        el.style.outline = ''
      }
      el.__cmsHandlers.push({ target: el, event: mouseEnterHandler as EventListener, event_type: 'mouseenter' })
      el.__cmsHandlers.push({ target: el, event: mouseLeaveHandler as EventListener, event_type: 'mouseleave' })
      el.addEventListener('mouseenter', mouseEnterHandler)
      el.addEventListener('mouseleave', mouseLeaveHandler)

      const contextMenuStore = useVideoContextMenuOptionsShowStatesStore()
      const contextHandler = () => {
        chosenPath = el._cmsPath
        isChoosenGlobal = el._global
        contextMenuStore.toggleVisible()
      }

      el.__cmsHandlers.push({ target: el, event: contextHandler, event_type: 'contextmenu' })
      el.addEventListener('contextmenu', contextHandler)

      const label = document.createElement('div')
      label.textContent = 'Editable video'
      label.style.cssText = 'position:fixed;padding:2px 6px;font-size:10px;background:rgba(0,0,0,.7);color:#fff;pointer-events:none;z-index:9999'
      document.body.appendChild(label)
      label.style.display = 'none'
      el.__cmsLabel = label

      const positionLabel = () => {
        const rect = el.getBoundingClientRect()
        label.style.top = `${rect.top}px`
        label.style.left = `${rect.left}px`
      }

      const show = (e: KeyboardEvent) => {
        if (!e.shiftKey) return
        positionLabel()
        label.style.display = 'block'
        el.style.outline = '2px solid blue'
      }
      const hide = () => {
        label.style.display = 'none'
        el.style.outline = ''
      }
      window.addEventListener('scroll', positionLabel, true)
      window.addEventListener('resize', positionLabel)
      el.__cmsHandlers.push({ target: window, event: positionLabel, event_type: 'scroll' })
      el.__cmsHandlers.push({ target: window, event: positionLabel, event_type: 'resize' })
      el.__cmsHandlers.push({ target: window, event: show, event_type: 'keydown' })
      el.__cmsHandlers.push({ target: window, event: hide, event_type: 'keyup' })
      window.addEventListener('keydown', show)
      window.addEventListener('keyup', hide)
    },

    updated(el: CmsElement, binding: DirectiveBinding) {
      if (!binding.arg) return
      const editStore = useCmsEditStore()
      editStore.set(el._cmsPath, { component_type: 'CmsVideo', component_data: binding.arg as CmsVideo }, el._global)
    },

    unmounted(el: CmsElement) {
      for (const h of el.__cmsHandlers ?? []) {
        h.target.removeEventListener(h.event_type, h.event as EventListener)
      }
      el.__cmsHandlers = []
      if (el.__cmsLabel && el.__cmsLabel.parentNode) {
        el.__cmsLabel.parentNode.removeChild(el.__cmsLabel)
      }
      el.__cmsLabel = undefined
      if (JSON.stringify(chosenPath) === JSON.stringify(el._cmsPath)) {
        chosenPath = undefined
      }
    }
  })
})
